<template>
  <!-- 供应商管理 -->
  <div class="supplier">
    <div class="filterBox">
      <div class="filter-container">
        <div class="query-row filter-row">
          <b>供应商种类：</b>
          <a-radio-group
            name="radioGroup"
            v-model="character.customerType"
            @change="(e) => radioGroupChange(e, 'customerType', 'supplier')"
            :default-value="1"
            style="margin-right: 20px;"
          >
            <a-radio value>全部</a-radio>
            <a-radio
              v-for="item in customerType"
              :value="item.label"
              :key="item.label"
            >{{ item.value }}</a-radio>
          </a-radio-group>
        </div>
        <div style="margin-top: 10px; display: flex; align-items: center;">
          <b v-if="!isJb">供应商名称：</b>
          <a-input
            v-model="queryDataObj.companyName"
            v-if="!isJb"
            placeholder="请输入供应商名称"
            class="filter-item search-item"
            @pressEnter="queryClick"
            allow-clear
          />
          <b>创建开始日期：</b>
          <a-date-picker
            @change="onChangeDateStart"
            show-time
            format="YYYY-MM-DD HH:mm:ss"
            v-model="queryDataObj.createTimeStart"
            class="filter-item search-item"
            style="margin-right: 14px;"
            placeholder="请选择开始日期"
          />
          <b>创建结束日期：</b>
          <a-date-picker
            @change="onChangeDateEnd"
            show-time
            format="YYYY-MM-DD HH:mm:ss"
            v-model="queryDataObj.createTimeEnd"
            class="filter-item search-item"
            style="margin-right: 14px;"
            placeholder="请选择结束日期"
          />
          <a-button type="primary" class="filter-item filter-button" @click="queryClick">查询</a-button>
          <advancedSearch
            v-if="!isJb"
            style="margin-left: 14px;"
            @advancedSearch="advancedSearch"
            @save="save"
          />
          <a-button class="filter-item filter-button" v-if="!isJb" @click="resetClick">重置</a-button>
          <!-- <a-dropdown v-if="!isChild && !recycleBinShow">
            <a-menu slot="overlay">
              <a-menu-item key="2" v-hasPermission="'customer:delete'" @click="deleteDictionary">批量删除</a-menu-item>
            </a-menu>
            <a-button class="filter-item filter-button"> 更多操作
              <a-icon type="down"/>
            </a-button>
          </a-dropdown>-->
          <template v-if="isChild">
            <a-button
              type="primary"
              v-hasPermission="'customer:add'"
              icon="plus-circle"
              class="filter-item"
              @click="addClick"
              style="margin-left:40px"
            >{{this.$tree([], 'purchase/supplier/index')}}快速新建</a-button>
          </template>
        </div>
        <template v-if="!isChild && !recycleBinShow">
          <a-button
            type="primary"
            v-hasPermission="'customer:add'"
            icon="plus-circle"
            class="filter-item add-but"
            @click="addClick"
          >新建{{this.$tree([], 'purchase/supplier/index')}}</a-button>
          <a-button
            v-hasPermission="'customer:export'"
            icon="download"
            class="filter-item add-but"
            @click="exportClick"
            style="margin-left: 6px;background-color: rgb(250, 173, 20); color: white"
          >导出{{this.$tree([], 'purchase/supplier/index')}}</a-button>
        </template>
      </div>
    </div>
    <div class="contentdiv">
      <!-- :row-selection="rowSelection" -->
      <a-table
        :columns="isChild ? filterColumnss : filterColumn"
        :components="isChild ? componentesds : componentesd"
        :data-source="tableData"
        :loading="tableLoadding"
        :pagination="pagination"
        size="middle"
        :rowKey="(record,index)=>{return index}"
        :scroll="{ y: 456 }"
        @change="pageChange"
        bordered
      >
        <span v-if="isChild" slot="filterDropdown">
          <a-card>
            <a-checkbox-group
              style="display:grid"
              v-model="columnList"
              :options="checkColumns"
              :defaultValue="checkColumns"
              @change="checkChange"
            />
            <a-tag
              color="green"
              @click="getColumns('suppliers')"
              style="position: absolute; right: 5px; bottom: 5px"
            >确认</a-tag>
          </a-card>
        </span>
        <span v-if="!isChild" slot="filterDropdown">
          <a-card>
            <a-checkbox-group
              style="display:grid"
              v-model="columnList"
              :options="checkColumn"
              :defaultValue="checkColumn"
              @change="checkChange"
            />
            <a-tag
              color="green"
              @click="getColumns('supplier')"
              style="position: absolute; right: 5px; bottom: 5px"
            >确认</a-tag>
          </a-card>
        </span>
        <template slot="fileIds" slot-scope="text, record">
          <a-icon
            type="paper-clip"
            v-if="record.fileIds && record.fileIds !== null && record.fileIds !==''"
            :style="'color:' + storageColor"
          />
        </template>
        <template slot="linkName" slot-scope="text, record">
          <a-tooltip placement="bottom">
            <template slot="title">
              <div v-for="(item,index) in record.linkmanList" :key="index">
                <span>{{item.linkmanName}}：{{item.linkmanTel}}</span>
              </div>
            </template>
            <a-icon
              type="phone"
              v-if="record.linkmanList !== [] && record.linkmanList.length>0"
              :style="'color:' + storageColor"
              style="cursor: pointer;"
            />
          </a-tooltip>
        </template>
        <template slot="titleCol" slot-scope="text, record">
          <a-tooltip placement="topLeft">
            <template slot="title">{{record.companyName}}</template>
            <span @click="titleClick(record)" class="onClickStyle">{{ record.companyName }}</span>
          </a-tooltip>
        </template>
        <template slot="customerType" slot-scope="text, record">
          <span>{{ suppliersObj[record.customerType] }}</span>
        </template>
        <template slot="operation" slot-scope="text, record">
          <template v-if="!isChild && !recycleBinShow">
            <span v-if="record.creator === nowUserName">
              <a-tooltip>
                <template slot="title">修改</template>
                <a-icon
                  type="edit"
                  theme="twoTone"
                  style="font-size: 16px;"
                  twoToneColor="#1890ff"
                  @click="editClick(record)"
                />
              </a-tooltip>
              <a-divider type="vertical" />
              <a-popconfirm
                v-if="tableData.length"
                title="确定删除这条数据吗?"
                @confirm="() => pageDelete(record)"
              >
                <a-tooltip>
                  <template slot="title">删除</template>
                  <a-icon
                    type="delete"
                    style="font-size: 16px; cursor: pointer;"
                    theme="twoTone"
                    twoToneColor="red"
                  />
                </a-tooltip>
              </a-popconfirm>
            </span>
            <span v-else>
              <span v-hasPermission="'customer:update'">
                <a-tooltip>
                  <template slot="title">修改</template>
                  <a-icon
                    type="edit"
                    theme="twoTone"
                    style="font-size: 16px;"
                    twoToneColor="#1890ff"
                    @click="editClick(record)"
                  />
                </a-tooltip>
              </span>
              <span v-hasPermission="'customer:delete'">
                <a-divider type="vertical" />
                <a-popconfirm
                  v-if="tableData.length"
                  title="确定删除这条数据吗?"
                  @confirm="() => pageDelete(record)"
                >
                  <a-tooltip>
                    <template slot="title">删除</template>
                    <a-icon
                      type="delete"
                      style="font-size: 16px; cursor: pointer;"
                      theme="twoTone"
                      twoToneColor="red"
                    />
                  </a-tooltip>
                </a-popconfirm>
              </span>
            </span>
          </template>
          <template v-if="isChild">
            <span class="operationStyle" style="color:#52c41a;" @click="selectClick(record)">选择</span>
          </template>
          <template v-if="recycleBinShow">
            <!-- <span class="operationStyle" style="color:#1890ff;" @click="editClick(record)">修改</span> -->
            <span>
              <!-- <a-divider type="vertical"/> -->
              <a-popconfirm title="确定恢复该数据吗？" @confirm="() => recovery(record)">
                <a-tooltip>
                  <template slot="title">恢复</template>
                  <a-icon type="sync" class="pointStyle" style="color:#2db7f5" />
                </a-tooltip>
                <!-- <span class="operationStyle" style="color:red;">删除</span> -->
              </a-popconfirm>
            </span>
            <span>
              <a-divider type="vertical" />
              <a-popconfirm title="确定删除这条数据吗？删除无法恢复！" @confirm="() => deleteRecy(record)">
                <a-tooltip>
                  <template slot="title">删除</template>
                  <a-icon type="delete" class="pointStyle" style="color:red" />
                </a-tooltip>
                <!-- <span class="operationStyle" style="color:red;">删除</span> -->
              </a-popconfirm>
            </span>
          </template>
        </template>
        <!-- <template v-if="recycleBinShow" slot="operation" slot-scope="text, record">
          <template>
            <span>
              <a-popconfirm
                title="确定恢复该数据吗？"
                @confirm="() => recovery(record)"
              >
              <a-tooltip>
                <template slot="title">恢复</template>
                <a-icon type="sync" class="pointStyle" style="color:#2db7f5"/>
              </a-tooltip>
              </a-popconfirm>
            </span>
            <span>
              <a-divider type="vertical"/>
              <a-popconfirm
                title="确定删除这条数据吗？删除无法恢复！"
                @confirm="() => deleteRecy(record)"
              >
              <a-tooltip>
                <template slot="title">删除</template>
                <a-icon type="delete" class="pointStyle" style="color:red"/>
              </a-tooltip>
              </a-popconfirm>
            </span>
          </template>
        </template>-->
      </a-table>
    </div>
    <addEdit
      :timeProcessings="timeProcessings"
      ref="addEdit"
      :customer-type="customerType"
      :title="moduleTitle"
      :dialog-visible="dialogVisible"
      @success="success"
      @close="close"
    />
    <message ref="message" :dialog-visible="detailVisible" @close="closeDetail" />

    <!-- <detail
      ref="detail"
      :dialog-visible="detailVisible"
      :dict-data="dictData"
      @close="closeDetail"
    />-->
    <view-vue
      ref="viewRef"
      :dialog-visible="viewVisible"
      :customer-type="customerType"
      @close="closeView"
    />
  </div>
</template>

<script>
import message from './message.vue'
import addEdit from './addEdit.vue'
import { getNowFormatDate } from '../../../utils/timer'
// import viewVue from './view.vue'
import viewVue from '@/views/customerManage/detail.vue'
import advancedSearch from '@/components/advancedSearch/index.vue'
import { mixin } from '@/mixin/index.js'
import { getQuery } from '@/mixin/getQuery.js'
var tableData = []
export default {
  name: 'Supplier',
  props: {
    isChild: {
      type: Boolean,
      default: false
    },
    recycleBinShow: {
      type: Boolean,
      default: false
    },
    isJb: { // 是否只显示捷报的供应商
      type: Boolean,
      default: false
    }
  },
  mixins: [getQuery, mixin],
  components: {
    addEdit,
    message,
    viewVue,
    advancedSearch
  },
  data () {
    return {
      dataForm: {},
      customerTypeData: [],
      nowUserName: this.$db.get('USER').username,
      storageColor: this.$db.get('COLOR')[0],
      timeProcessings: this.timeProcessing(),
      tableLoadding: false, // 表格加载
      dialogVisible: false, // 新建弹窗
      detailVisible: false, // 详情弹窗
      viewVisible: false, // 视图弹窗
      moduleTitle: '新建项目',
      tableData: tableData || [],
      selectedRowKeys: [], // 选中的行
      customerType: [],
      suppliersObj: {},
      character: {
        customerType: '',
        companyName: '',
        createTimeStart: null,
        createTimeEnd: null
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true, // 是否可以快速跳转至某页
        showSizeChanger: true // 是否可以改变pageSize
      },
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
        }
      },
      advancedEnquiries: [
        {
          type: 'input',
          label: '供应商名称',
          key: 'companyName',
          defaultModel: true,
          modelKey: 'queryDataObj'
        },
        {
          type: 'input',
          label: '联系人',
          key: 'linkName',
          defaultModel: true,
          modelKey: 'queryDataObj'
        },
        {
          type: 'input',
          label: '编号',
          key: 'customerCode',
          defaultModel: true,
          modelKey: 'queryDataObj'
        },
        {
          type: 'input',
          label: '所有者',
          key: 'creator',
          defaultModel: true,
          modelKey: 'queryDataObj'
        },
        {
          type: 'time',
          label: '创建起始日期',
          key: 'createTimeStart',
          defaultModel: true,
          modelKey: 'queryDataObj'
        },
        {
          type: 'time',
          label: '创建结束日期',
          key: 'createTimeEnd',
          defaultModel: true,
          modelKey: 'queryDataObj'
        },
        {
          type: 'radio',
          label: '供应商种类',
          layout: 24,
          key: 'customerType',
          content: [
            { label: '全部', value: '' }
          ],
          defaultModel: true,
          modelKey: 'queryDataObj'
        }
        // {
        //   type: 'person',
        //   isOnce: false,
        //   label: '抄送人',
        //   layout: 24,
        //   key: 'user'
        // }
      ]
    }
  },
  provide () {
    return {
      advancedEnquiries: this
    }
  },
  computed: {
    columns () {
      return [
        {
          title: 'ID',
          dataIndex: 'id',
          width: 100,
          // sorter: (a, b) => a.id - b.id,
          align: 'center',
          ellipsis: true
        },
        {
          title: '附件',
          dataIndex: 'fileIds',
          width: 60,
          align: 'center',
          ellipsis: true,
          scopedSlots: { customRender: 'fileIds' }
        },
        {
          width: 100,
          align: 'center',
          title: '联系人',
          dataIndex: 'linkName',
          scopedSlots: { customRender: 'linkName' }
        },
        {
          title: '供应商名称',
          dataIndex: 'companyName',
          ellipsis: true,
          width: 150,
          scopedSlots: { customRender: 'titleCol' }
        },
        {
          title: '编号',
          dataIndex: 'customerCode',
          width: 220,
          align: 'center',
          ellipsis: true
        },
        {
          title: '种类',
          dataIndex: 'customerType',
          width: 150,
          align: 'center',
          ellipsis: true,
          scopedSlots: { customRender: 'customerType' }
        },
        {
          title: '所有者',
          dataIndex: 'creator',
          width: 150,
          align: 'center',
          // colSpan: (this.$route.path === '/purchase/supplier' ? 1 : 0),
          ellipsis: true
        },
        {
          title: '创建日期',
          dataIndex: 'createTime',
          width: 200,
          align: 'center',
          // colSpan: (this.$route.path === '/purchase/supplier' ? 1 : 0),
          ellipsis: true
        },
        {
          title: '操作',
          align: 'center',
          ellipsis: true,
          dataIndex: 'operation',
          onFilterDropdownVisibleChange: (e) => this.onFilterDropdownVisibleChange(e, 'supplier'),
          scopedSlots: { customRender: 'operation', filterDropdown: 'filterDropdown', filterIcon: 'filterIcon' }
        }
      ]
    },
    columnss () {
      return [
        {
          title: '操作',
          dataIndex: 'operation',
          width: 160,
          onFilterDropdownVisibleChange: (e) => this.onFilterDropdownVisibleChange(e, 'suppliers'),
          scopedSlots: { customRender: 'operation', filterDropdown: 'filterDropdown', filterIcon: 'filterIcon' }
        },
        {
          title: '供应商名称',
          dataIndex: 'companyName',
          width: 160,
          ellipsis: true,
          scopedSlots: { customRender: 'titleCol' }
        },
        {
          title: '编号',
          dataIndex: 'customerCode',
          width: 200,
          ellipsis: true
        },
        {
          title: '种类',
          dataIndex: 'customerType',
          width: 150,
          ellipsis: true,
          scopedSlots: { customRender: 'customerType' }
        },
        {
          title: '所有者',
          dataIndex: 'creator',
          width: 150,
          // align: 'center',
          // colSpan: (this.$route.path === '/purchase/supplier' ? 1 : 0),
          ellipsis: true
        },
        {
          title: '创建日期',
          dataIndex: 'createTime',
          // width: 200,
          align: 'center',
          // colSpan: (this.$route.path === '/purchase/supplier' ? 1 : 0),
          ellipsis: true
        }
      ]
    }
  },
  // 监听ischild变化
  watch: {
    isChild: {
      handler (val) {
        if (val) {
          this.rowSelection = null
        }
      },
      immediate: true
    },
    isJb: {
      handler (val) {
        if (val) {
          this.character.companyName = '捷报'
        }
      },
      immediate: true
    }
  },
  created () {
    if (this.isChild) {
      this.geTableColumn('suppliers')
    } else {
      this.geTableColumn('supplier')
    }
  },
  mounted () {
    if (this.$store.state.queryCriteria.queryList.supplier) {
      this.character = this.queryDataObj = this.$store.state.queryCriteria.queryList.supplier
    }
    this.initData(this.character)
    this.initDectData()
  },
  methods: {
    // 重置
    resetAdvancedSearch () {
      this.pagination.current = 1
    },
    // 保存并查询
    advancedSearch () {
      this.resetAdvancedSearch()
      this.character = { ...this.character, ...this.dataForm, ...this.queryDataObj }
      this.setQueryList({ supplier: this.character })
      this.initData(this.character)
    },
    // 直接查询不保存
    save () {
      this.resetAdvancedSearch()
      let character = { ...this.character, ...this.dataForm }
      this.initData(character)
      this.dataForm = {}
    },
    onChangeDateStart (val, mode) {
      this.queryDataObj.createTimeStart = mode
    },
    onChangeDateEnd (val, mode) {
      this.queryDataObj.createTimeEnd = mode
    },
    timeProcessing () {
      let time = getNowFormatDate()
      return 'GYS' + time + Math.floor(Math.random() * 10000)
    },
    initData (params = {}) {
      this.tableLoadding = true
      params.pageNum = this.pagination.current
      params.pageSize = this.pagination.pageSize
      params.type = 2
      if (this.recycleBinShow) {
        params.delFlag = 1
      } else {
        delete params.delFlag
      }
      if (this.isChild) {
        this.$get('customer/getAll', { ...params }).then(res => {
          if (res.status === 200 && res.data.status === 1) {
            let data = res.data
            this.pagination.total = Number(data.data.total)
            this.tableData = data.data.rows
            setTimeout(() => {
              this.tableLoadding = false
            }, 500)
          } else {
            this.$message.error(res.data.message)
            setTimeout(() => {
              this.tableLoadding = false
            }, 500)
          }
        })
      } else {
        this.$get('/customer/list', { ...params }).then(res => {
          if (res.status === 200 && res.data.status === 1) {
            let data = res.data
            this.pagination.total = Number(data.data.total)
            this.tableData = data.data.rows
            setTimeout(() => {
              this.tableLoadding = false
            }, 500)
          } else {
            this.$message.error(res.data.message)
            setTimeout(() => {
              this.tableLoadding = false
            }, 500)
          }
        })
      }
    },
    // 数据字典查询
    initDectData () {
      this.customerType = this.$store.state.account.dictData.supplierTypeList
      this.suppliersObj = this.$store.state.account.dictData.supplierTypeObj
      this.customerType.forEach(e => {
        this.advancedEnquiries[6].content.push({
          label: e.value,
          value: e.label
        })
      })
      // console.log(this.customerType, 'customerType')
    },
    exportClick () {
      this.$download('/customer/export', { ...this.character, pageSize: -1, pageNum: -1, type: 2 }, `${new Date().getTime()}${this.$tree([], 'purchase/supplier/index')}.xlsx`)
    },
    recovery (value) {
      const parma = {}
      if (value.parentId) {
        parma.parentId = value.parentId
      }
      parma.linkId = value.id
      parma.recycleType = 3
      parma.type = 2
      this.$get('/recycle/recover', { ...parma }).then(res => {
        if (res.data.status) {
          this.$message.success(res.data.message)
          this.initData()
        } else {
          this.$message.warning(res.data.message)
        }
      })
    },
    deleteRecy (value) {
      const parma = {}
      if (value.parentId) {
        parma.parentId = value.parentId
      }
      parma.linkId = value.id
      parma.recycleType = 3
      parma.type = 2
      this.$get('/recycle/del', { ...parma }).then(res => {
        if (res.data.status) {
          this.$message.success(res.data.message)
          this.initData()
        } else {
          this.$message.warning(res.data.message)
        }
      })
    },
    queryClick () {
      this.pagination.current = 1
      let character = { ...this.character, ...this.queryDataObj }
      this.character = Object.assign({}, this.character, this.queryDataObj)
      this.initData({ ...character })
      this.setQueryList({ supplier: character })
    },
    resetClick () {
      this.character = {
        customerType: '',
        customerName: ''
      }
      this.dataForm = {}
      this.queryDataObj = {}
      let character = { ...this.character, ...this.queryDataObj }
      this.setQueryList({ supplier: character })
      this.pagination.current = 1
      this.initData(...this.character)
    },
    addClick () {
      this.timeProcessings = this.timeProcessing()
      this.moduleTitle = `[新建]-${this.$tree([], 'purchase/supplier/index')}`
      this.dialogVisible = true
    },
    editClick (record) {
      this.moduleTitle = `[修改]-${this.$tree([], 'purchase/supplier/index')}`
      this.dialogVisible = true
      this.$refs.addEdit.initData(record)
    },
    pageDelete (record) {
      this.$get('/customer/delete', { ids: [record.id] }).then(res => {
        if (res.status === 200 && res.data.status === 1) {
          this.$message.success('删除成功')
          this.initData(this.character)
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    // 批量删除
    deleteDictionary () {
      if (this.selectedRowKeys.length === 0) {
        this.$message.warning('请选择要删除的数据')
        return
      }
      var that = this
      this.$confirm({
        title: '确定删除吗?',
        content: '删除后将无法恢复',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk: () => {
          const Arr = this.selectedRowKeys
          const newDate = Arr.join(',')
          that.pageDelete({ id: newDate })
        }
      })
    },
    // 表格选中项发生变化的时的回调
    onSelectChange (selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    pageChange (pagination, filters, sorter) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.initData(this.character)
    },
    // 点击标题跳转到详情页
    titleClick (record) {
      // 校验-是否有权限访问
      this.$get('/customer/followCheck', { dataId: record.id }).then(res => {
        if (res.data.status === 1) {
          if (res.data.data) {
            this.viewVisible = true
            this.$nextTick(() => {
              this.$refs.viewRef.initData(record, record.id)
            })
          } else {
            this.$message.warning('暂无权限访问该数据!')
          }
        } else {
          this.$message.warning(res.data.message)
        }
      })
    },
    closeView () {
      this.initData(this.character)
      this.viewVisible = false
    },
    success () {
      this.dialogVisible = false
      this.pagination.current = 1
      if (this.character.companyName !== '' || this.character.customerType !== '') {
        this.initData(this.character)
      } else {
        this.initData()
      }
    },
    close () {
      this.dialogVisible = false
      if (this.character.companyName !== '' || this.character.customerType !== '') {
        this.initData(this.character)
      } else {
        this.initData()
      }
    },
    closeDetail () {
      this.detailVisible = false
    },
    selectClick (val) {
      this.$emit('selectClick', val)
    }
  }
}
</script>

<style lang="less" scoped>
.contentdiv {
  padding: 4px 0px;
  width: 83vw;
}
.tableHiddle {
  display: none;
}
.tableShow {
  display: revert;
}
.filterBox {
  margin-left: -4px;
}
.supplier {
  width: 100%;

  // .filter-container {
  //   padding: 4px;
  //   margin: 10px;
  //   background-color: #fff;
  // }

  .filter-row {
    margin-bottom: 14px;
  }

  .filter-button {
    margin-left: 20px;
  }

  .filter-item {
    display: inline-block;
    vertical-align: middle;
  }

  .search-item {
    margin-right: 14px;
    width: 200px;
  }

  .add-but {
    margin-top: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/purchase/supplier/index.vue